// © 2025 Camp Promethean, LLC. All Rights Reserved.
// Dark-first visual tokens for Hands-Free.

export const hfDark = "dark bg-background text-foreground";

export const hfShell =
  `${hfDark} hf-shell flex min-h-[calc(100svh-3.5rem)] flex-1 flex-col`;

export const hfCard = "border-border/50 bg-card shadow-sm";
export const hfCardHeader = "border-b border-border/50 bg-muted/30 pb-4";
export const hfCardTitle = "font-heading text-lg font-light tracking-tight text-foreground";
export const hfTabsList =
  "inline-flex h-auto w-full rounded-lg border border-border/50 bg-muted/30 p-1";
export const hfEmptyState =
  "flex flex-col items-center justify-center rounded-lg border border-dashed border-border/50 bg-muted/20 px-6 py-12 text-center";
export const hfRecordButton =
  "relative h-20 w-20 rounded-full bg-primary text-primary-foreground shadow-lg shadow-primary/20 transition-transform hover:scale-[1.02] active:scale-[0.98]";
export const hfRecordPulse = "app-loading-screen__pulse-ring absolute inset-0 rounded-full";

export const hfWarnAlert =
  "border-amber-500/30 bg-amber-500/10 text-amber-100 [&>svg]:text-amber-400";
export const hfWarnTitle = "text-amber-100";
export const hfWarnBody = "text-amber-200/90";
export const hfSuccessBanner = "border-primary/30 bg-primary/10 text-foreground";
export const hfSuccessAlert = "border-emerald-500/30 bg-emerald-500/10 text-emerald-100";
